import React from 'react'

import ContactForm from '../../../react4xp/components/ContactForm'

function ContactFormPart({ strings, sendEmailServiceUrl, termsAndConditionsUrl, products, user, recaptcha }) {
    return (
        <ContactForm
            title={strings.heading}
            desc={strings.intro}
            sendEmailServiceUrl={sendEmailServiceUrl}
            termsAndConditionsUrl={termsAndConditionsUrl}
            products={products}
            strings={strings}
            user={user}
            recaptcha={recaptcha}
            dividers={{
                hideBottomDivider: true,
                hideTopDivider: true
            }}
        />
    )
}

export default (props) => <ContactFormPart {...props} />
